import React from "react";
import styled from "styled-components";
import {mediaQuery} from "../../styles/constants/mediaQuery";

export const Restricted = () => {
    return (
        <Container>
            <WrapperComponents>
                <div className="item-title">
                    <h2>
                        No disponible por orden del Gral

                    </h2>
                    <h3>
                        La gestión es presencial en el CGE
                    </h3>
                </div>
            </WrapperComponents>
        </Container>
    );
};

const Container = styled.div`
  width: 100%;
  height: auto;

  .item-title {
    padding: 4em 1em 0 1em;
      text-align: center;
    h2 {
      text-align: center;
    }
  }
`;

const WrapperComponents = styled.div`
  width: 100%;
  max-width: 1250px;
  height: auto;
  margin: auto;
  padding: 1em;
  ${mediaQuery.minTablet} {
    padding-top: 130px;
  }
`;
